/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hours: NonNullable<unknown> }} Cases_Settings_Hourssuffix1Inputs */

const en_cases_settings_hourssuffix1 = /** @type {(inputs: Cases_Settings_Hourssuffix1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hours}h`)
};

/**
* | output |
* | --- |
* | "{hours}h" |
*
* @param {Cases_Settings_Hourssuffix1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_settings_hourssuffix1 = /** @type {((inputs: Cases_Settings_Hourssuffix1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Hourssuffix1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_hourssuffix1(inputs)
});
export { cases_settings_hourssuffix1 as "cases_settings_hoursSuffix" }